import React from 'react';
import { useNavigate } from 'react-router-dom';

function ProDashboardPromo() {
  const navigate = useNavigate();
  const isLoggedIn = !!localStorage.getItem('token');

  return (
    <div className="pro-dashboard">
      <div className="pro-promo">
        <h1 className="pro-promo-title">Pro Dashboard requires Pro account</h1>

        <div className="pro-promo-image-wrapper">
          <img src={`${process.env.PUBLIC_URL}/assets/images/pro-dash-example1.png`} alt="Pro Dashboard example" className="pro-promo-image" />
        </div>

        <div className="pro-promo-features">
          <div className="pro-promo-feature">
            <span className="pro-promo-feature-icon">&#9632;</span>
            <div>
              <h3>Customizable Widgets</h3>
              <p>Choose from a variety of charts and data widgets to build your perfect dashboard</p>
            </div>
          </div>
          <div className="pro-promo-feature">
            <span className="pro-promo-feature-icon">&#9632;</span>
            <div>
              <h3>Custom Layout Saved in the Cloud</h3>
              <p>Arrange widgets however you like — your layout is saved and synced across devices</p>
            </div>
          </div>
          <div className="pro-promo-feature">
            <span className="pro-promo-feature-icon">&#9632;</span>
            <div>
              <h3>Custom Filters Saved in the Cloud</h3>
              <p>Set your preferred filters on each widget and they persist between sessions</p>
            </div>
          </div>
          <div className="pro-promo-feature">
            <span className="pro-promo-feature-icon">&#9632;</span>
            <div>
              <h3>Scheduled Emails</h3>
              <p>Receive a daily email of your dashboard data at the time you choose</p>
            </div>
          </div>
        </div>

        <div className="pro-promo-cta">
          {isLoggedIn ? (
            <button className="pro-promo-btn" onClick={() => navigate('/support')}>
              Upgrade to Pro
            </button>
          ) : (
            <button className="pro-promo-btn" onClick={() => navigate('/login')}>
              Log In to Get Started
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default ProDashboardPromo;
